import { pgTable, uuid, jsonb, index, foreignKey, text, } from 'drizzle-orm/pg-core';
import { orgTableBase, orgPrimaryKey } from '../org-id';
import { LibraryExercise } from './exercises';
import { Profile } from '../profile';
import { Block } from '../block';
import { Org } from '../org';
import { relations } from 'drizzle-orm';
export const AthleteExerciseActuals = pgTable('athlete_exercise_actuals', {
    ...orgTableBase,
    profileId: uuid('profile_id').notNull(),
    libraryExerciseId: uuid('library_exercise_id').notNull(),
    workoutId: uuid('workout_id').notNull(),
    workoutExerciseId: uuid('workout_exercise_id').notNull(),
    workoutSectionId: uuid('workout_section_id').notNull(),
    workoutSupersetId: uuid('workout_superset_id'),
    workoutSupersetExerciseId: uuid('workout_superset_exercise_id'),
    workoutAlternateGroupId: uuid('workout_alternate_group_id'),
    workoutAlternateExerciseId: uuid('workout_alternate_exercise_id'),
    workoutName: text('workout_name').notNull(),
    blockId: uuid('block_id').notNull(),
    note: text('note'),
    instruction: text('instruction'),
    sets: jsonb('sets')
        .$type()
        .notNull()
        .default([]),
}, (table) => ({
    pk: orgPrimaryKey(table),
    // Foreign key constraints
    orgFk: foreignKey({
        columns: [table.orgId],
        foreignColumns: [Org.id],
    }),
    profileFk: foreignKey({
        columns: [table.orgId, table.profileId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
    exerciseFk: foreignKey({
        columns: [table.orgId, table.libraryExerciseId],
        foreignColumns: [LibraryExercise.orgId, LibraryExercise.id],
    }),
    blockFk: foreignKey({
        columns: [table.orgId, table.blockId],
        foreignColumns: [Block.orgId, Block.id],
    }),
    // Indexes for common query patterns
    athleteExerciseIdx: index('idx_athlete_exercise_actuals_athlete_exercise').on(table.orgId, table.profileId, table.libraryExerciseId),
    workoutIdx: index('idx_athlete_exercise_actuals_workout').on(table.orgId, table.workoutId),
}));
export const AthleteExerciseActuals_Relations = relations(AthleteExerciseActuals, ({ one }) => ({
    profile: one(Profile, {
        fields: [AthleteExerciseActuals.orgId, AthleteExerciseActuals.profileId],
        references: [Profile.orgId, Profile.id],
    }),
    libraryExercise: one(LibraryExercise, {
        fields: [
            AthleteExerciseActuals.orgId,
            AthleteExerciseActuals.libraryExerciseId,
        ],
        references: [LibraryExercise.orgId, LibraryExercise.id],
    }),
    block: one(Block, {
        fields: [AthleteExerciseActuals.orgId, AthleteExerciseActuals.blockId],
        references: [Block.orgId, Block.id],
    }),
}));
//# sourceMappingURL=athlete-exercise-actuals.js.map